import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IscoConfiguration } from 'src/app/configuration/isco/isco-configuration';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class IscoService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }

  ricercaIscoByIdProfilo(id:any): Observable<any[]> {
    return this.http.get<any[]>(IscoConfiguration.ricercaIscoByIdProfilo + id, { headers: this.headers });
  }

  ricercaIscoByIdCompetenza(id:any): Observable<any[]> {
    return this.http.get<any[]>(IscoConfiguration.ricercaIscoByIdCompetenza + id, { headers: this.headers });
  }

  ricercaIsco(data: any, page: number, pageSize: number, searchType: number): Observable<any[]> {
    return this.http.post<any[]>(IscoConfiguration.ricercaIsco + page + "/" + pageSize + "/" + searchType, data, { headers: this.headers });
  }

  salvaIscoByIdProfilo(data:any,id:any) {
    return this.http.post<any[]>(IscoConfiguration.salvaIscoByIdProfilo + id, data, { headers: this.headers });
  }

  salvaIscoByIdCompetenza(data:any,id:any) {
    return this.http.post<any[]>(IscoConfiguration.salvaIscoByIdCompetenza + id, data, { headers: this.headers });
  }

  getCodiciIscoByIdProposta(id:any): Observable<any[]> {
    return this.http.get<any[]>(IscoConfiguration.getCodiciIscoByIdProposta + id, { headers: this.headers });
  }

  getCodiciIscoByIdCompetenza(id:any): Observable<any[]> {
    return this.http.get<any[]>(IscoConfiguration.getCodiciIscoByIdCompetenza + id, { headers: this.headers });
  }

  getElencoIsco(data: string): Observable<any[]> {
    return this.http.get<any[]>(IscoConfiguration.getElencoIsco + data, { headers: this.headers });
  }
}
